import { Box, Paper, Typography } from "@mui/material";

const TLPurchaseOnAccount = () => (
  <Box m={{ xs: 1.5, md: 3 }}>
    <Typography variant="h3" fontWeight={800}>Purchase On Account</Typography>
    <Typography color="text.secondary" mb={2}>Manage purchases made on supplier credit.</Typography>
    <Paper
      elevation={0}
      sx={{ minHeight: 420, p: 3, border: "1px solid", borderColor: "divider", borderRadius: 3 }}
    >
      <Typography color="text.secondary">The Purchase On Account transaction list will be displayed here.</Typography>
    </Paper>
  </Box>
);

export default TLPurchaseOnAccount;
